import { createEntityAdapter, createReducer } from '@reduxjs/toolkit';
import {
  deploymentFetchAllFailureAction
, deploymentFetchAllRequestAction
, deploymentFetchAllSuccessAction
, fetchDeploymentFailureAction
, fetchDeploymentRequestAction
, fetchDeploymentSuccessAction
} from './deploymentsActions';
import { DeploymentModel } from '../../models/deploymentModel';
import { DeploymentsStateModel } from './deploymentsStateModel';

export const deploymentAdapter = createEntityAdapter<DeploymentModel>();

const initialState: DeploymentsStateModel = deploymentAdapter.getInitialState({
  loading: false,
  errors: [],
});

export const deploymentsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(deploymentFetchAllRequestAction, (state) => {
      state.loading = true;
      state.errors = [];
    })
    .addCase(deploymentFetchAllSuccessAction, (state, action) => {
      state.loading = false;
      deploymentAdapter.setAll(state, action.payload);
    })
    .addCase(deploymentFetchAllFailureAction, (state, action) => {
      state.loading = false;
      state.errors = [...state.errors, action.payload];
    })

    .addCase(fetchDeploymentRequestAction, (state) => {
      state.loading = true;
      state.errors = [];
    })
    .addCase(fetchDeploymentSuccessAction, (state, action) => {
      state.loading = false;
      deploymentAdapter.setOne(state, action.payload);
    })
    .addCase(fetchDeploymentFailureAction, (state, action) => {
      state.loading = false;
      state.errors = [...state.errors, action.payload];
    });
});
